/**
 * Validation service
 */
angular.module("exploitation").factory("ValidationService", ["$http", "ENV", function ($http, ENV) {


	/**
     * API
     */
	const api = {
		getLatestValidation: getLatestValidation,
		validate: validate,
		scheduleManualValidationExport: scheduleManualValidationExport,
		getNextScheduledValidationExport: getNextScheduledValidationExport,
		getLatestStorageTime: getLatestStorageTime,
		getRestorationStorageTime: getRestorationStorageTime,
		restoreReferential: restoreReferential
	};

	function getLatestValidation(refId) {
		return $http.get(ENV.EVENTS_BASE_URL + "timetable/" + refId
			+ "?action=DATASPACE_TRANSFER&action=VALIDATION_LEVEL_2&latest=true", {
			transformRequest: angular.identity,
			headers: {
				"Content-Type": undefined
			}
		});
	}

	function validate(providerId, user) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/validate", {
			headers: {
				"Content-Type": "application/json",
				"Accept": "application/json",
				"RutebankenUser": user,
			}
		});
	}

	function scheduleManualValidationExport(providerId, when) {
		return $http.post(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/validate/schedule/",
			{
				"validationSchedule": when
			},
			{
				headers: {
					"Content-Type": "application/json",
				}
			});
	}

	function getNextScheduledValidationExport(providerId) {
		return $http.get(ENV.TIMETABLE_ADMIN_BASE_URL + providerId + "/validate/schedule", {
			headers: {
				"Accept": "application/json"
			}
		});
	}

	function getLatestStorageTime(referential) {
		return $http.get(ENV.IEV_URL + "/referentials/" + referential + "/latest_storage_time");
	}

	function getRestorationStorageTime(referential) {
		return $http.get(ENV.IEV_URL + "/referentials/" + referential + "/restoration_storage_time");
	}

	function restoreReferential(referential) {
		return $http.get(ENV.API_URL + "/restore/" + referential);
	}

	return api;
}]);
